// @ts-ignore
import { registerUidProvider } from '/vodalys2023/talkto/uid_provider'

import { debug } from "/vodalys/.jslibs/";
const log = debug('Visio2:UidProvider')

function visio2ToUidProvider() {

	const paramsMatch = window.location.hash.match(/#\/?(.*)-(.*)-(.*)/);
	if (!paramsMatch) {
		log('Undefined UID')
		return
	} else {
		let [, pushHash, roomUid, streamUid] = paramsMatch;
		log(`uid ${streamUid}`)
		return streamUid;
	}


}

registerUidProvider('visio2_uid_provider', visio2ToUidProvider)